module.exports = __webpack_public_path__ + "img/p4_new02.8fcaadc1.png";